// eslint-disable-next-line prefer-destructuring
export const PYDIO_ENDPOINT = process.env.PYDIO_ENDPOINT;
export const AUTHENTICATION_ENDPOINT = process.env.AUTHENTICATION_ENDPOINT;
export const FILE_TEMPLATE = `${PYDIO_ENDPOINT}?action=embed&repo=insync&file=%s`;
export const STAGE_TEMPLATE = `${PYDIO_ENDPOINT}?action=get_stage&repo=insync&file=%s`;
export const DATA_ENDPOINT = "/measurement-python/ws";
export const SBF_DATA_ENDPOINT = "/sbf-data";
